import React from 'react';
import './AdditionalMenuList.scss';

const AdditionalMenuList: React.FC = props => {
  return <ul className="AdditionalMenuList">{props.children}</ul>;
};

export default AdditionalMenuList;
